import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import close from "../../../assets/close.png";
import Logo from "../../../assets/logo2.png";
import axios from "axios";
import ProfileDropdown from "./ProfileDropdown";
import NotificationIcon from "./NotificationIcon";

const emptyStats = {
  totalEstablishments: 0,
  totalClients: 0,
  totalSupervisors: 0,
  totalUsers: 0,
  activeUsers: 0,
  kycVerifiedUsers: 0,
  pendingKycUsers: 0,
  pendingWages: 0,
  pendingPfEsic: 0,
};

const SuperAdminDashboard = () => {
  const token = localStorage.getItem("token");
  const [dashboard, setDashboard] = useState(null);
  const [loading, setLoading] = useState(true);

  const stats = dashboard?.stats || emptyStats;
  const recent = dashboard?.recent || {
    establishments: [],
    clients: [],
    supervisors: [],
    users: [],
  };

  async function fetchDashboard() {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/super-admin/dashboard`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDashboard();
  }, []);

  function menuClickHandler() {
    document.querySelector("#sidebarCollapse").style.left = "0";
    document.querySelector(".menu-close").style.display = "block";
    document.querySelector("#menu_button").style.display = "none";
  }

  function closeClickHandler() {
    document.querySelector("#sidebarCollapse").style.left = "-100%";
    document.querySelector(".menu-close").style.display = "none";
    document.querySelector("#menu_button").style.display = "block";
  }

  const summaryCards = [
    {
      title: "Establishments",
      value: stats.totalEstablishments,
      hint: "Total registered businesses",
      icon: "bi-buildings",
      type: "establishments",
    },
    {
      title: "Clients",
      value: stats.totalClients,
      hint: "Client accounts across the platform",
      icon: "bi-briefcase",
      type: "clients",
    },
    {
      title: "Supervisors",
      value: stats.totalSupervisors,
      hint: "Operational supervisors",
      icon: "bi-person-badge",
      type: "supervisors",
    },
    {
      title: "Users",
      value: stats.totalUsers,
      hint: "Registered workforce accounts",
      icon: "bi-people",
      type: "users",
    },
  ];

  const healthCards = [
    {
      title: "Active Users",
      value: stats.activeUsers,
      tone: "success",
      type: "active-users",
    },
    {
      title: "KYC Verified",
      value: stats.kycVerifiedUsers,
      tone: "primary",
      type: "kyc-verified",
    },
    {
      title: "Pending KYC",
      value: stats.pendingKycUsers,
      tone: "warning",
      type: "pending-kyc",
    },
    {
      title: "Pending Wages",
      value: stats.pendingWages,
      tone: "danger",
      type: "pending-wages",
    },
    {
      title: "Pending PF/ESIC",
      value: stats.pendingPfEsic,
      tone: "secondary",
      type: "pending-pf-esic",
    },
  ];

  return (
    <div>
      <style>{`
        .superadmin-shell {
          min-height: 100vh;
        }

        .superadmin-main {
          min-width: 0;
          width: 100%;
        }

        .superadmin-card-link {
          color: inherit;
          text-decoration: none;
          display: block;
          height: 100%;
        }

        .superadmin-clickable-card {
          transition: transform 0.15s ease, box-shadow 0.15s ease;
          cursor: pointer;
        }

        .superadmin-clickable-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 0.75rem 1.5rem rgba(15, 23, 42, 0.08) !important;
        }

        @media (min-width: 992px) {
          .superadmin-sidebar {
            position: sticky !important;
            top: 0;
            align-self: flex-start;
            width: 280px;
            min-width: 280px;
            height: 100vh;
            overflow-y: auto;
            z-index: 10;
          }

          .superadmin-main {
            width: calc(100% - 280px);
          }
        }

        @media (max-width: 991.98px) {
          .superadmin-sidebar {
            width: 100%;
            min-width: 100%;
            height: auto;
            position: relative !important;
          }
        }
      `}</style>
      <div className="superadmin-shell d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <nav
          className="superadmin-sidebar navbar show navbar-vertical h-lg-screen navbar-expand-lg px-0 py-0 navbar-light bg-white border-bottom border-bottom-lg-0 border-end-lg"
          id="navbarVertical"
        >
          <div className="container-fluid" id="sidebar_div">
            <a className="" id="navbar_brand" href="#">
              <img src={Logo} alt="Logo" />
            </a>
            <div className="gap-4" id="nav_menu_div">
              <ProfileDropdown />
              <button
                className="navbar-toggler ms-n2"
                type="button"
                onClick={menuClickHandler}
                id="menu_button"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <img
                onClick={closeClickHandler}
                className="menu-close"
                src={close}
                alt="close menu"
              />
            </div>

            <div className="sidebarCollapse" id="sidebarCollapse">
              <ul className="navbar-nav" id="nav_div">
                <li className="nav-item" id="nav_item">
                  <a className="nav-link" href="#overview">
                    <i className="bi bi-grid"></i> Overview
                  </a>
                </li>
                <li className="nav-item" id="nav_item">
                  <a className="nav-link" href="#health">
                    <i className="bi bi-activity"></i> Platform Health
                  </a>
                </li>
                <li className="nav-item" id="nav_item">
                  <a className="nav-link" href="#directory">
                    <i className="bi bi-table"></i> Entity Directory
                  </a>
                </li>
                <li className="nav-item" id="nav_item">
                  <Link className="nav-link" to="/superadmin-settings">
                    <i className="bi bi-gear"></i> Settings
                  </Link>
                </li>
                <li className="nav-item" id="nav_item">
                  <Link className="nav-link" to="/superadmin-report-types">
                    Report Types
                  </Link>
                </li>
                <li className="nav-item" id="nav_item">
                  <Link className="nav-link" to="/superadmin-form-types">
                    Form Types
                  </Link>
                </li>
                <li className="nav-item" id="nav_item">
                  <Link className="nav-link" to="/superadmin-login">
                    <i className="bi bi-shield-lock"></i> Super Admin Login
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="superadmin-main flex-grow-1 overflow-y-lg-auto" id="main_div">
          <header className="bg-surface-primary border-bottom pt-6" id="dashboard_header">
            <div className="container-fluid">
              <div className="mb-npx">
                <div className="row align-items-center">
                  <div className="col-lg-8 col-12 mb-4 mb-lg-0">
                    <h1 className="h2 mb-0 ls-tight">
                      Welcome {dashboard?.currentUser?.name || "Super Admin"}
                    </h1>
                    <p className="text-muted mb-0 mt-2">
                      Monitor the full platform, track operational bottlenecks,
                      and review recent account activity from one place.
                    </p>
                  </div>
                  <div className="col-lg-4 col-12 text-lg-end">
                    <div className="profile_pic_toggle d-flex justify-content-lg-end align-items-center gap-2 flex-wrap">
                      <NotificationIcon />
                      <ProfileDropdown />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <div className="container-fluid py-4">
            <section id="overview" className="mb-4">
              <div className="row g-4">
                {summaryCards.map((card) => (
                  <div className="col-12 col-md-6 col-xl-3" key={card.title}>
                    <Link
                      to={`/superadmin-records/${card.type}`}
                      className="superadmin-card-link"
                    >
                      <div className="card superadmin-clickable-card shadow-sm border-0 h-100">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start">
                            <div>
                              <div className="text-muted small text-uppercase fw-semibold">
                                {card.title}
                              </div>
                              <div className="display-6 fw-bold mt-2">
                                {loading ? "..." : card.value}
                              </div>
                              <div className="text-muted mt-2">{card.hint}</div>
                              <div className="small text-primary fw-semibold mt-3">
                                View full list
                              </div>
                            </div>
                            <div className="fs-3 text-primary">
                              <i className={`bi ${card.icon}`}></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </section>

            <section id="health" className="mb-4">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h4 className="mb-1">Platform Health</h4>
                      <p className="text-muted mb-0">
                        High-level operational indicators a super user should
                        watch daily.
                      </p>
                    </div>
                  </div>
                  <div className="row g-3">
                    {healthCards.map((card) => (
                      <div className="col-12 col-sm-6 col-xl" key={card.title}>
                        <Link
                          to={`/superadmin-records/${card.type}`}
                          className="superadmin-card-link"
                        >
                          <div className={`superadmin-clickable-card border rounded-3 p-3 h-100 bg-${card.tone}-subtle`}>
                            <div className="small text-muted fw-semibold">
                              {card.title}
                            </div>
                            <div className="h3 mb-0 mt-2">{loading ? "..." : card.value}</div>
                            <div className="small text-primary fw-semibold mt-3">
                              Open matching records
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>

            <section id="directory" className="mb-4">
              <div className="row g-4">
                <div className="col-12 col-xxl-6">
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                      <h5 className="mb-3">Recent Establishments</h5>
                      <div className="table-responsive">
                        <table className="table table-sm align-middle">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Users</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recent.establishments.length ? (
                              recent.establishments.map((item) => (
                                <tr key={item._id}>
                                  <td>{item.name || "—"}</td>
                                  <td>{item.email || "—"}</td>
                                  <td>{item.users?.length || 0}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-muted text-center py-3">
                                  No establishment data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xxl-6">
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                      <h5 className="mb-3">Recent Supervisors</h5>
                      <div className="table-responsive">
                        <table className="table table-sm align-middle">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Establishment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recent.supervisors.length ? (
                              recent.supervisors.map((item) => (
                                <tr key={item._id}>
                                  <td>{item.name || "—"}</td>
                                  <td>{item.email || "—"}</td>
                                  <td>{item.establisment?.name || "—"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-muted text-center py-3">
                                  No supervisor data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xxl-6">
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                      <h5 className="mb-3">Recent Clients</h5>
                      <div className="table-responsive">
                        <table className="table table-sm align-middle">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Establishment</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recent.clients.length ? (
                              recent.clients.map((item) => (
                                <tr key={item._id}>
                                  <td>{item.name || "—"}</td>
                                  <td>{item.email || "—"}</td>
                                  <td>{item.establisment?.name || "—"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-muted text-center py-3">
                                  No client data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-xxl-6">
                  <div className="card shadow-sm border-0 h-100">
                    <div className="card-body">
                      <h5 className="mb-3">Recent Users</h5>
                      <div className="table-responsive">
                        <table className="table table-sm align-middle">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>KYC</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recent.users.length ? (
                              recent.users.map((item) => (
                                <tr key={item._id}>
                                  <td>{item.full_Name || "—"}</td>
                                  <td>{item.email || "—"}</td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        item.kyc ? "bg-success" : "bg-warning text-dark"
                                      }`}
                                    >
                                      {item.kyc ? "Verified" : "Pending"}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={`badge ${
                                        item.active_user_status
                                          ? "bg-primary"
                                          : "bg-secondary"
                                      }`}
                                    >
                                      {item.active_user_status ? "Active" : "Inactive"}
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-muted text-center py-3">
                                  No user data available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
